import React, { useMemo } from 'react';
import { useContractsList } from '../../../contextsProperty/ContextContractsList';
import Calendar from '../../../../components/calendar/Calendar';
import useCalendar from '../../../../customHooks/useCalendar';
import {
    CalendarEvent,
    CalendarView,
} from '../../../../types/calendar/calendarTypes';
import { IContractListState } from '../../../../types/contracts/contractTypes';
import ContractsEvent from './ContractsEvent';
import { buildContractsCalendarEvents } from '../../../../utils/contractUtils/contractsListUtils';

const ContractsCalendar = () => {
    const { items, isLoading } = useContractsList();
    const {
        calendarRef,
        activeView,
        changeView,
        goToDate,
        prev,
        next,
        today,
        idHoveredEvent,
        hoverEvent,
        unhoverEvent,
    } = useCalendar({
        initialView: CalendarView.MONTH,
    });

    const events: CalendarEvent<IContractListState>[] = useMemo(() => {
        return buildContractsCalendarEvents(items);
    }, [items]);

    const renderEvent = (event: CalendarEvent<IContractListState>) => {
        return (
            <ContractsEvent
                event={event}
                idHoveredEvent={idHoveredEvent}
                hoverEvent={hoverEvent}
                unhoverEvent={unhoverEvent}
            />
        );
    };

    return (
        <div className='flex-grow overflow-y-auto'>
            <Calendar
                calendarRef={calendarRef}
                events={events}
                renderEvent={renderEvent}
                eventColor={'var(--background)'}
                isLoading={isLoading}
                onNext={next}
                onPrev={prev}
                onToday={today}
                onViewChange={changeView}
                onGoToDate={goToDate}
                activeView={activeView}
            />
        </div>
    );
};

export default ContractsCalendar;
